import React from 'react'

class EditSaveBtn extends React.Component{

  constructor(props){
    super(props)
    this.state = {
      editMode: false
    }
  }

  isEditMode(){
    return this.state.editMode
  }

  reverseSaveEditMode(){
    this.setState({      
      editMode: !this.state.editMode
    })
  }
  render(){
    return (this.state.editMode)?<span>&#x1f5ab;</span>:<span>&#x270E;</span>
  }
}
export default EditSaveBtn;